import { useEffect, useMemo } from 'react';

import { makeCsvFileAndUrl } from '../utils';

export const useCsvFileUrl = (csv: string): string => {
  const { revokeUrl, url } = useMemo(() => makeCsvFileAndUrl(csv), [csv]);
  // Revoke the file URL when the component unmounts
  useEffect(() => revokeUrl, [revokeUrl]);
  return url;
};
